// Import Containers
import {
  App,
  AnimationSample,
  // WP1
  Html,
  FooterNavigation,
  SocialIconsContainerBlock,
  // WP2
  SiteSearch,
  PrimaryNavigation,
  PromoNavigationItem,
  PhotoInfo,
  // WP3
  RelatedVideo,
  Promo,
  Wysiwyg,
  OneColumnLayout,
  TwoColumnLayout,
  ThreeColumnLayout,
  FourColumnLayout,
  PresentationItem,
  PhotogalleryLayout,
  // WP4
  Cta,
  ExteriorViewAccessories,
  TabNavigation,
  // WP5
  BodySize,
  EquipmentItem,
  MakerSetOptionMoreInfoItem,
  OwnerLibraryContainer,
  EcoTax,
  //GradeAndSpec,
  //GradeAndSpecData,
  // WP6
  Pagenation,
  Notification,
  //CreditPlan,
  OwnerLibrary,
  // WP7
  AnchorNavigation,
  BreadcrumbNavigation,
  DriversVoice,
  CarsComparison,
  DealerDetailContent,
  // WP8
  Sitemap,
  EstimationHistory,
  // 2020/09
  PromoAndButtonModalWindow,
  // 2021/06
  MyMazda,
} from 'containers'

// Import Components
import {
  Accordion,
  Hyperlink,
  ModalWindow,
  NavigationContainer,
  ScrollTop,
  Slider,
  Wrapper,
  YoutubePlayer,
  ImageLoader,
} from 'components'

// Import Blocks
// WP1
import SubFooterNavigation from './sub-footer-navigation';
import HomePage from './home-page';
// WP2
import PromoNavigationContainer from './promo-navigation-container';
import PromoNavigation from './promo-navigation';
import GlobalNavigation from './global-navigation';
import Header from './header';
import SubNavigation from './sub-navigation';
import HeroImage from './hero-image';
import HeroVideo from './hero-video';
import HeroCarousel from './hero-carousel';
import StandardPage from './standard-page';
// WP3
import FullWidth from './full-width';
import Video from './video';
import Slideshow from './slideshow';
import Presentation from './presentation';
import Photogallery from './photogallery';
import PhotogalleryItem from './photogallery-item';
import Slidegallery from './slidegallery';
import SlidegalleryItem from './slidegallery-item';
// WP4
import FeatureCategories from './feature-categories';
import FeatureCategoryContainer from './feature-category-container';
import Picker from './picker';
import PickerContainer from './picker-container';
import PickerItem from './picker-item';
import ExteriorView from './exterior-view';
import PromoSlider from './promo-slider';
// WP5
import Equipment from './equipment';
import EquipmentContainer from './equipment-container';
import MakerSetOption from './maker-set-option';
import SpecComparison from './spec-comparison';
import GradeAndSpec from './grade-and-spec';
import GradeAndSpecData from './grade-and-spec-data';
import CarLineup from './car-lineup';
import CarLineupFilter from './car-lineup-filter';
import CarLineupFilterItem from './car-lineup-filter-item';
// WP6
import CarNavigation from './car-navigation';
import CarNavigationLinkItem from './car-navigation-link-item';
import CreditPlan from './credit-plan';
// WP7
import AccordionContainer from './accordion-container';
import AccordionItem from './accordion-item';
import CTANavigation from './cta-navigation';
import AccessoryList from './accessory-list';
import AccessoryBodyTypeTabName from './accessory-body-type-tab-name';
import AccessoryDetailPage from './accessory-detail-page'
import AccessoryDetailContent from './accessory-detail-content'
import AccessoryInfoContainer from './accessory-info-container'
import AccessoryInfoItem from './accessory-info-item'

// 2021/08
import Interior360 from './interior360'
import Interior360Item from './interior360-item'

// Export All
export {
  App,
  AnimationSample,
  // WP1
  Html,
  FooterNavigation,
  SocialIconsContainerBlock,
  SubFooterNavigation,
  HomePage,
  // WP2
  SiteSearch,
  PrimaryNavigation,
  PromoNavigationItem,
  PromoNavigationContainer,
  PromoNavigation,
  GlobalNavigation,
  Header,
  SubNavigation,
  PhotoInfo,
  HeroVideo,
  HeroImage,
  HeroCarousel,
  StandardPage,
  // WP3
  FullWidth,
  Video,
  RelatedVideo,
  Promo,
  Wysiwyg,
  OneColumnLayout,
  TwoColumnLayout,
  ThreeColumnLayout,
  FourColumnLayout,
  Slideshow,
  Presentation,
  PresentationItem,
  Photogallery,
  PhotogalleryItem,
  PhotogalleryLayout,
  Slidegallery,
  SlidegalleryItem,
  // WP4
  Cta,
  FeatureCategories,
  FeatureCategoryContainer,
  Picker,
  PickerContainer,
  PickerItem,
  TabNavigation,
  ExteriorView,
  ExteriorViewAccessories,
  PromoSlider,
  // WP5
  BodySize,
  Equipment,
  EquipmentContainer,
  EquipmentItem,
  MakerSetOptionMoreInfoItem,
  MakerSetOption,
  SpecComparison,
  OwnerLibraryContainer,
  GradeAndSpecData,
  GradeAndSpec,
  EcoTax,
  CarLineup,
  CarLineupFilter,
  CarLineupFilterItem,
  // WP6
  Pagenation,
  CarNavigation,
  CarNavigationLinkItem,
  Notification,
  CreditPlan,
  OwnerLibrary,
  //WP7
  AccordionContainer,
  AccordionItem,
  AnchorNavigation,
  BreadcrumbNavigation,
  CTANavigation,
  DriversVoice,
  AccessoryList,
  AccessoryBodyTypeTabName,
  AccessoryDetailPage,
  AccessoryDetailContent,
  AccessoryInfoContainer,
  AccessoryInfoItem,
  CarsComparison,
  DealerDetailContent,
  //WP8
  Sitemap,
  EstimationHistory,
  // 2020/09
  PromoAndButtonModalWindow,
  // 2021/06
  MyMazda,
  // 2021/08
  Interior360,
  Interior360Item,
}



// WEBPACK FOOTER //
// ./src/blocks/index.js